<template>
  <div>
    <b-row align-h="center">
      <b-col sm="12" md="10" lg="8" style="background: #fff" class="p-4">
        <router-link :to="getReturnLink()">Revenir à l'accueil</router-link>
        <h4 class="mt-4">
          D&eacute;claration de consentement &agrave; la signification
          &eacute;lectronique des actes d&rsquo;Huissiers de Justice&nbsp;
        </h4>
        <h5>CONDITIONS G&Eacute;N&Eacute;RALES D&rsquo;UTILISATION</h5>
        <h6>1 - Pr&eacute;ambule</h6>
        <p>
          Conform&eacute;ment aux dispositions de l&rsquo;article 662-1 du Code
          de proc&eacute;dure civile cr&eacute;&eacute; par le d&eacute;cret
          n&deg;2012-366 du 15 mars 2012 relatif &agrave; la signification des
          actes d&rsquo;huissier de justice par voie &eacute;lectronique et aux
          notifications internationales, les Etudes d&rsquo;Huissiers de Justice
          ont la possibilit&eacute; de signifier leurs actes par voie
          &eacute;lectronique aux Tiers saisis.
        </p>
        <p>
          A compter du 1er janvier 2021, et en application des dispositions de
          l&rsquo;article 15 de la loi n&deg;2019-222 du 23 mars 2019 de
          programmation 2018-2022 et de r&eacute;forme pour la justice, les
          Etudes d&rsquo;Huissiers de Justice devront obligatoirement signifier
          leurs actes de saisie attribution ou de saisie conservation par voie
          &eacute;lectronique aux &eacute;tablissements bancaires (<em
            >Tiers saisis</em
          >).&nbsp;
        </p>
        <p>
          La signification par voie &eacute;lectronique d&rsquo;un acte
          d&rsquo;huissier de justice &eacute;tant subordonn&eacute;e &agrave;
          une d&eacute;claration pr&eacute;alable de consentement du Tiers saisi
          (<em>ci-apr&egrave;s le "Destinataire"</em>), la Chambre Nationale des
          Commissaires de Justice (<em>ci-apr&egrave;s la "CNCJ"</em>) est
          charg&eacute;e de tenir &agrave; jour, dans le respect des
          dispositions de la loi n&deg;78-17 du 6 janvier 1978 relative &agrave;
          l&rsquo;informatique, aux fichiers et aux libert&eacute;s, la liste
          des personnes ayant consenti &agrave; recevoir un acte de
          signification par voie &eacute;lectronique.
        </p>
        <p>
          C&rsquo;est dans ces conditions que la CNCJ met &agrave; disposition
          des &eacute;tablissements bancaires, une plateforme
          d&eacute;di&eacute;e pour s&rsquo;inscrire au
          r&eacute;f&eacute;rentiel national de d&eacute;p&ocirc;t des
          consentements &agrave; la signification
          d&eacute;mat&eacute;rialis&eacute;e, accessible &agrave;
          l&rsquo;adresse URL<a
            href="https://inscription-securact.commissaire-justice.fr"
            target="_blank"
            >https://inscription-securact.commissaire-justice.fr.</a
          >
        </p>
        <h6>2 - D&eacute;finitions</h6>
        <p>
          Pour la lecture des Conditions G&eacute;n&eacute;rales, les termes
          ci-dessous d&eacute;finis auront entre les parties la signification
          suivante&nbsp;:
        </p>
        <p>
          <strong>D&eacute;claration de consentement</strong> : d&eacute;signe
          l&rsquo;acte par lequel le Destinataire d&rsquo;un acte
          d&rsquo;Huissier de justice accepte de recevoir la signification dudit
          acte par voie &eacute;lectronique.
        </p>
        <p>
          <strong>Destinataire</strong> : d&eacute;signe, dans le cadre de la
          Plateforme, l&rsquo;&eacute;tablissement bancaire (<em
            >ou Tiers saisi</em
          >) ayant accept&eacute; de recevoir les actes signifi&eacute;s par
          Huissier de Justice par voie &eacute;lectronique.
        </p>
        <p>
          <strong>Responsable d&rsquo;exploitation</strong> : d&eacute;signe la
          personne, au sein de l&rsquo;&eacute;tablissement bancaire, en charge
          du dossier de signification.
        </p>
        <p>
          <strong>Plateforme de D&eacute;p&ocirc;t des Consentements</strong> :
          d&eacute;signe la Plateforme mise &agrave; disposition des
          &eacute;tablissements bancaires par la CNCJ afin de recueillir leur
          consentement &agrave; recevoir les actes de signification par voie
          d&eacute;mat&eacute;rialis&eacute;e.
        </p>
        <p>
          <strong>Signataire</strong> : d&eacute;signe la personne physique, au
          sein de l&rsquo;&eacute;tablissement bancaire, habilit&eacute;e
          &agrave; signer la convention d&rsquo;&rdquo;Accord avec la Chambre
          Nationale des Commissaires de Justice pour consentement &agrave;
          recevoir les actes d&rsquo;Huissiers de Justice par voie
          &eacute;lectronique&rdquo;.
        </p>
        <p>
          <strong>Tiers Saisi</strong> : d&eacute;signe la personne physique ou
          morale qui d&eacute;tient des sommes d&rsquo;argent appartenant au
          D&eacute;biteur principal d&eacute;faillant. En l&rsquo;esp&egrave;ce,
          le Tiers Saisi est un &eacute;tablissement, habilit&eacute; par la loi
          &agrave; tenir des comptes de d&eacute;p&ocirc;t, au sens des articles
          L511-1 et suivants du Code mon&eacute;taire et financier, qui
          d&eacute;sire consentir &agrave; la signification par voie
          &eacute;lectronique.
        </p>
        <h6>3 - Objet</h6>
        <p>
          Les Conditions G&eacute;n&eacute;rales ont pour objet de
          d&eacute;finir&nbsp;les conditions et modalit&eacute;s
          d&rsquo;utilisation de la Plateforme de D&eacute;p&ocirc;t des
          Consentements (<em>ci-apr&egrave;s la &ldquo;Plateforme&rdquo;</em>)
          par le Destinataire de l&rsquo;acte de signification.
        </p>
        <h6>4 - Conditions d'acc&egrave;s a la Plateforme</h6>
        <p>
          <strong
            >4.1 - Phase de pr&eacute;-enregistrement du consentement</strong
          >
        </p>
        <p>
          Dans une premi&egrave;re &eacute;tape, le Destinataire se connecte
          &agrave; la Plateforme
          <a
            href="https://inscription-securact.commissaire-justice.fr"
            target="_blank"
            >https://inscription-securact.commissaire-justice.fr.</a
          >et est invit&eacute; &agrave; renseigner son adresse professionnelle
          de courrier &eacute;lectronique ainsi que son code d&rsquo;activation
          personnalis&eacute;.
        </p>
        <p>
          Les modalit&eacute;s de mise &agrave; disposition du code
          d&rsquo;activation seront communiqu&eacute;es au Destinataire depuis
          l&rsquo;extranet du CFONB.
        </p>
        <p>
          Le Destinataire est ensuite invit&eacute; &agrave; renseigner : son
          adresse de courrier &eacute;lectronique. Un code d&rsquo;activation
          lui est ensuite adress&eacute; afin de proc&eacute;der &agrave; son
          inscription.
        </p>
        <p>
          Le Destinataire doit&nbsp;fournir les renseignements ci-dessous
          :&nbsp;
        </p>
        <p>1/ Num&eacute;ro SIRET de l&rsquo;Etablissement bancaire ;&nbsp;</p>
        <p>
          2/ Domiciliation (<em>adresse, code postal, nom de la ville</em>) ;
        </p>
        <p>
          3/ Responsable d&rsquo;exploitation (<em
            >c&rsquo;est &agrave; dire la personne charg&eacute;e de
            g&eacute;rer les op&eacute;rations de saisie au sein de
            l&rsquo;&eacute;tablissement bancaire</em
          >) :
        </p>
        <ul>
          <li>nom</li>
          <li>pr&eacute;nom</li>
          <li>qualit&eacute;</li>
          <li>adresse email</li>
          <li>num&eacute;ro de t&eacute;l&eacute;phone fixe</li>
          <li>
            email g&eacute;n&eacute;rique (<em
              >pour recevoir les notifications</em
            >)
          </li>
        </ul>
        <p>
          4/ Signataire de la convention : civilit&eacute;, pr&eacute;nom, nom,
          qualit&eacute;, num&eacute;ro de t&eacute;l&eacute;phone mobile.
        </p>
        <p>
          Le Destinataire est inform&eacute; que les champs accompagn&eacute;s
          d&rsquo;un ast&eacute;risque doivent &ecirc;tre obligatoirement
          renseign&eacute;s. A d&eacute;faut, l&rsquo;inscription &agrave; la
          Plateforme ne pourra pas &ecirc;tre prise en compte.
        </p>
        <p>
          Une fois ces informations remplies, l&rsquo;&eacute;tape de
          pr&eacute;-enregistrement est termin&eacute;e. Un courrier
          &eacute;lectronique est ensuite adress&eacute; au Signataire afin de
          l&rsquo;informer que la convention d&rsquo;&rdquo;<em
            >Accord avec la Chambre Nationale des Commissaires de Justice pour
            consentement &agrave; recevoir les actes d&rsquo;Huissiers de
            Justice par voie &eacute;lectronique</em
          >&rdquo; est en attente de sa signature.
        </p>
        <p><strong>4.2 - Signature de la convention</strong></p>
        <p>
          Pour proc&eacute;der &agrave; la signature de la convention, le
          Signataire re&ccedil;oit par courrier &eacute;lectronique un code qui
          doit lui permettre, au moyen de son adresse de courrier professionnel,
          de se connecter &agrave; la Plateforme afin de donner son &ldquo;<em
            >Accord avec la Chambre Nationale des Commissaires de Justice pour
            consentement &agrave; recevoir les actes d&rsquo;Huissiers de
            Justice par voie &eacute;lectronique</em
          >&rdquo;.
        </p>
        <p>
          Le Signataire est ensuite invit&eacute; &agrave; saisir ses nom,
          pr&eacute;nom, date de naissance (<em>jour/ mois/ ann&eacute;e</em>),
          puis &agrave; t&eacute;l&eacute;charger sa Carte Nationale
          d&rsquo;Identit&eacute; ainsi que son attestation employeur.
        </p>
        <p>
          Ces documents sont obligatoires afin de permettre &agrave; la CNCJ de
          v&eacute;rifier l&rsquo;identit&eacute; du Signataire.
        </p>
        <p>
          S&rsquo;affiche ensuite la convention intitul&eacute;e &ldquo;<em
            >Accord relatif aux modalit&eacute;s de signification par voie
            &eacute;lectronique des mesures conservatoires et des mesures
            d&rsquo;ex&eacute;cution sur compte bancaire au tiers saisi</em
          >&rdquo;. Le Signataire est invit&eacute; &agrave; prendre
          connaissance de chaque page de la convention en cliquant sur
          l&rsquo;onglet &ldquo;suivant&rdquo; et &agrave; signer
          &eacute;lectroniquement le document.
        </p>
        <p>
          <strong
            >4.3 - Acceptation des Conditions G&eacute;n&eacute;rales&nbsp;et
            respect des dispositions l&eacute;gales et r&eacute;glementaires en
            vigueur</strong
          >
        </p>
        <p>
          Tout acc&egrave;s et utilisation de la Plateforme suppose la
          consultation et l'acceptation sans r&eacute;serve des pr&eacute;sentes
          Conditions G&eacute;n&eacute;rales ainsi que le respect des
          dispositions l&eacute;gales et r&eacute;glementaires en vigueur.
        </p>
        <p>
          Le Destinataire reconna&icirc;t &ecirc;tre parfaitement inform&eacute;
          du fait que son accord concernant le contenu des Conditions
          G&eacute;n&eacute;rales ne n&eacute;cessite pas la signature
          manuscrite de ce document mais r&eacute;sulte de sa seule acceptation
          en ligne via la case &agrave; cocher &laquo;&nbsp;j&rsquo;ai lu et
          j&rsquo;accepte les conditions g&eacute;n&eacute;rales &raquo;. Le
          refus des Conditions G&eacute;n&eacute;rales ne permet pas de valider
          l'acc&egrave;s &agrave; la Plateforme.
        </p>
        <h6>5 - Entr&eacute;e en vigueur &ndash; Dur&eacute;e</h6>
        <p>
          Les Conditions G&eacute;n&eacute;rales entrent en vigueur &agrave;
          compter de leur acceptation par le Destinataire qui s&rsquo;effectue
          via la case &agrave; cocher &laquo;&nbsp;j&rsquo;ai lu et
          j&rsquo;accepte les conditions
          g&eacute;n&eacute;rales&nbsp;&raquo;.&nbsp;
        </p>
        <p>
          Les Conditions G&eacute;n&eacute;rales sont conclues pour une
          dur&eacute;e ind&eacute;termin&eacute;e &agrave; compter de leur
          acceptation.&nbsp;
        </p>
        <p>
          Le Destinataire est inform&eacute; qu&rsquo;il peut &agrave; tout
          moment r&eacute;voquer son consentement &agrave; tout moment. La
          r&eacute;vocation du consentement entra&icirc;ne la r&eacute;siliation
          des pr&eacute;sentes Conditions G&eacute;n&eacute;rales. A compter de
          la r&eacute;siliation, le Destinataire ne peut plus acc&eacute;der
          &agrave; la Plateforme.
        </p>
        <h6>6 - Mise en garde g&eacute;n&eacute;rale</h6>
        <p>
          Le Destinataire acc&egrave;de &agrave; la Plateforme par
          l'interm&eacute;diaire des r&eacute;seaux de communication de
          l'Internet. Le Destinataire d&eacute;clare &agrave; ce titre en
          conna&icirc;tre les risques et les accepter. Le Destinataire
          reconna&icirc;t notamment que les informations qui y transitent ou y
          sont stock&eacute;es peuvent &ecirc;tre intercept&eacute;es ou
          alt&eacute;r&eacute;es contre la volont&eacute; de la CNCJ.
        </p>
        <p>
          Le Destinataire reconna&icirc;t en outre avoir la comp&eacute;tence et
          les moyens notamment techniques n&eacute;cessaires pour acc&eacute;der
          &agrave; la Plateforme, et avoir v&eacute;rifi&eacute; que la
          configuration informatique utilis&eacute;e ne contient aucun virus et
          qu'elle est en parfait &eacute;tat de fonctionnement.&nbsp;
        </p>
        <p>
          Le Destinataire est &agrave; cet &eacute;gard inform&eacute; que la
          CNCJ ne saurait &ecirc;tre tenue pour responsable de sa mauvaise
          utilisation de la Plateforme.
        </p>
        <p>
          La CNCJ s&rsquo;efforcera d&rsquo;offrir au Destinataire la meilleure
          disponibilit&eacute; de la Plateforme. Cependant, la CNCJ ne fournit
          aucune garantie expresse ou implicite en termes de
          disponibilit&eacute; ou de performance, compte tenu de la structure du
          r&eacute;seau Internet.
        </p>
        <p>
          La Plateforme est accessible 24H/24 et 7J/ 7 sauf (i) survenance
          d&rsquo;un cas de force majeure tel que reconnu par la jurisprudence
          des tribunaux fran&ccedil;ais, (ii) survenance d&rsquo;un
          &eacute;v&egrave;nement ind&eacute;pendant de la volont&eacute; de la
          CNCJ ou, (iii) dysfonctionnements, perturbations, interruptions
          li&eacute;es aux r&eacute;seaux de t&eacute;l&eacute;communications
          non imputables &agrave; la CNCJ.
        </p>
        <p>
          La Plateforme peut &eacute;galement &ecirc;tre interrompue &agrave;
          tout moment pour des raisons de s&eacute;curit&eacute;. En cas de
          maintenance programm&eacute;e, le Destinataire sera inform&eacute; par
          voie d&rsquo;affichage directement sur la Plateforme ou par mail.
        </p>
        <p>
          La CNCJ se r&eacute;serve le droit de suspendre l'acc&egrave;s
          &agrave; la Plateforme et/ou son utilisation en cas de non-respect par
          le Destinataire des Conditions G&eacute;n&eacute;rales, en cas de
          survenance d&rsquo;un &eacute;v&egrave;nement impactant la
          s&eacute;curit&eacute; de la Plateforme ou en cas de
          pr&eacute;somption d&rsquo;une utilisation non autoris&eacute;e ou
          frauduleuse.
        </p>
        <h6>7 - Support Technique</h6>
        <p>
          Le Destinataire peut contacter les membres du support technique de la
          Plateforme &agrave; l'adresse &eacute;lectronique suivante :<a
            href="mailto:inscription-securact@commissaire-justice.fr"
            >inscription-securact@commissaire-justice.fr</a
          >
        </p>
        <p>Le support technique est disponible du lundi au vendredi&nbsp;:</p>
        <ul>
          <li>de 9 H00 &agrave; 12 H30</li>
          <li>
            de 13H30 &agrave; 17H30 du lundi au jeudi et de 13H30 &agrave; 17H
            le vendredi
          </li>
        </ul>
        <h6>8 - Propri&eacute;t&eacute; Intellectuelle</h6>
        <p>
          La CNCJ est titulaire des droits de propri&eacute;t&eacute;
          intellectuelle ou d&eacute;tient les droits n&eacute;cessaires sur
          l&rsquo;ensemble des &eacute;l&eacute;ments constituant la Plateforme,
          tels que sans limitation, les d&eacute;veloppements informatiques et
          logiciels, les bases de donn&eacute;es, les documentations, les
          &eacute;l&eacute;ments visuels ou sonores, graphismes, marques et
          logos. L'ensemble de ces &eacute;l&eacute;ments est soumis aux
          dispositions du Code de la propri&eacute;t&eacute; intellectuelle
          fran&ccedil;ais.
        </p>
        <p>
          Le Destinataire est autoris&eacute; &agrave; consulter,
          t&eacute;l&eacute;charger et &agrave; imprimer les documents et
          informations disponibles aux conditions suivantes :
        </p>
        <ul>
          <li>
            les documents ne peuvent &ecirc;tre utilis&eacute;s qu'&agrave;
            titre personnel, pour information et dans un cadre strictement
            priv&eacute; conform&eacute;ment &agrave; l'article L122-5 2&deg; du
            Code de Propri&eacute;t&eacute; Intellectuelle
          </li>
          <li>
            les documents et informations ne peuvent &ecirc;tre modifi&eacute;s
            de quelque mani&egrave;re que ce soit
          </li>
          <li>
            les documents et informations ne peuvent &ecirc;tre diffus&eacute;s
            en dehors de la Plateforme
          </li>
        </ul>
        <p>
          Les droits accord&eacute;s au Destinataire constituent une simple
          autorisation d'utilisation et en aucun cas une cession des droits de
          propri&eacute;t&eacute; intellectuelle aff&eacute;rents aux
          &eacute;l&eacute;ments de la Plateforme.
        </p>
        <p>
          Toute utilisation ou reproduction, totale ou partielle, de la
          Plateforme, des &eacute;l&eacute;ments qui la composent, des signes
          distinctifs, et/ou des informations qui figurent sur la Plateforme par
          quelque proc&eacute;d&eacute; que ce soit, est strictement interdite
          et constitue une contrefa&ccedil;on sanctionn&eacute;e par le Code de
          la propri&eacute;t&eacute; intellectuelle fran&ccedil;ais, sauf accord
          pr&eacute;alable et &eacute;crit de la soci&eacute;t&eacute;.
        </p>
        <h6>9 - Conditions financieres</h6>
        <p>
          La Plateforme de D&eacute;p&ocirc;t du Consentement est mise &agrave;
          disposition du Destinataire &agrave; titre gratuit.
        </p>
        <h6>10 - R&eacute;vocation du consentement du Destinataire</h6>
        <p>
          Le Destinataire peut r&eacute;voquer son consentement &agrave;
          recevoir les actes de signification par voie &eacute;lectronique
          &agrave; tout moment. La r&eacute;vocation du consentement du
          Destinataire entra&icirc;ne la r&eacute;siliation des pr&eacute;sentes
          Conditions G&eacute;n&eacute;rales, sans indemnit&eacute;.
        </p>
        <p>
          A compter du 1er janvier 2021, le Destinataire est inform&eacute;
          qu&rsquo;il ne sera plus en mesure de r&eacute;voquer son
          consentement, dans la mesure o&ugrave; l a signification des actes
          d&rsquo;Huissiers de justice par voie &eacute;lectronique sera
          obligatoire, uniquement pour les proc&eacute;dures de
          saisie-attribution et de saisie-conservatoire. Dans les autres cas
          (<em
            >pour les proc&eacute;dures de saisie des droits incorporels et de
            saisie conservatoire des valeurs mobili&egrave;res</em
          >) le Destinataire pourra toujours r&eacute;voquer son consentement.
        </p>
        <h6>
          11 - NON RESPECT DES CONDITIONS GENERALES D&rsquo;UTILISATION OU DES
          DISPOSITIONS LEGALES ET REGLEMENTAIRES
        </h6>
        <p>
          En cas de non-respect des pr&eacute;sentes Conditions
          G&eacute;n&eacute;rales ou de violation de dispositions l&eacute;gales
          et/ou r&eacute;glementaires, la CNCJ pourra prendre les mesures
          conservatoires qui s&rsquo;imposent et autoris&eacute;es par la loi
          afin de faire respecter lesdites Conditions G&eacute;n&eacute;rales
          d&rsquo;Utilisation.
        </p>
        <p>
          La CNCJ pourra &eacute;galement suspendre temporairement
          l&rsquo;acc&egrave;s &agrave; la Plateforme, notamment dans les cas
          suivants, sans que sa responsabilit&eacute; ne puisse &ecirc;tre
          engag&eacute;e&nbsp;:
        </p>
        <ul>
          <li>
            Le Destinataire fait un usage de la Plateforme de nature &agrave;
            porter pr&eacute;judice aux droits de la CNCJ
          </li>
          <li>
            Le Destinataire utilise de fa&ccedil;on illicite ou ill&eacute;gale
            les informations transitant sur la Plateforme
          </li>
          <li>
            Le Destinataire acc&egrave;de ou se maintient frauduleusement dans
            la Plateforme, entrave ou alt&egrave;re le fonctionnement de
            celui-ci notamment en y introduisant des virus, chevaux de Troie,
            vers, bombes logiques ou tout autre programme susceptible de causer
            un dommage &agrave; la Plateforme et/ou de porter atteinte aux
            donn&eacute;es de la CNCJ
          </li>
          <li>
            Le Destinataire acc&egrave;de ou traite des donn&eacute;es &agrave;
            caract&egrave;re personnel de tiers de mani&egrave;re frauduleuse ou
            d&eacute;tourn&eacute;e
          </li>
        </ul>
        <p>
          Notamment dans de telles hypoth&egrave;ses, le Destinataire
          s&rsquo;exposerait &agrave; des poursuites judiciaires.
        </p>
        <h6>
          12 - Donn&eacute;es &agrave; caract&egrave;re personnel et Gestion des
          cookies
        </h6>
        <p>
          Le Destinataire d&eacute;clare &ecirc;tre inform&eacute; que les
          donn&eacute;es &agrave; caract&egrave;re personnel qu&rsquo;il
          communique sur la Plateforme font l&rsquo;objet d&rsquo;un traitement
          automatis&eacute; de donn&eacute;es personnelles au sens de la loi
          n&deg;78-17 du 6 janvier 1978 relative &agrave; l&rsquo;Informatique,
          au Fichier et aux Libert&eacute;s modifi&eacute;e par la loi
          n&deg;2018-493 du 20 juin 2018 relative &agrave; la protection des
          donn&eacute;es et du R&egrave;glement 2016/679 du Parlement et du
          Conseil du 27 avril 2016 relatif &agrave; la protection des personnes
          physiques &agrave; l&rsquo;&eacute;gard du traitement des
          donn&eacute;es &agrave; caract&egrave;re personnel et &agrave; la
          libre circulation de ces donn&eacute;es.
        </p>
        <p>
          Les donn&eacute;es &agrave; caract&egrave;re personnel
          communiqu&eacute;es par&nbsp;le Destinataire (<em
            >en ce compris les donn&eacute;es du Responsable
            d&rsquo;exploitation et du Signataire</em
          >) au moment de son pr&eacute;-enregistrement sont collect&eacute;es
          par la CNCJ, responsable d'exploitation, &agrave; des fins
          d&rsquo;identification du Destinataire &agrave; la Plateforme et de
          gestion de ses informations &agrave; recevoir les actes de
          signification par voie &eacute;lectronique.
        </p>
        <p>
          Les donn&eacute;es &agrave; caract&egrave;re personnel du Destinataire
          sont conserv&eacute;es pour la dur&eacute;e de son adh&eacute;sion
          &agrave; la Plateforme. Les donn&eacute;es &agrave; caract&egrave;re
          personnel du Destinataire sont d&eacute;truites &agrave;
          l&rsquo;expiration d&rsquo;un d&eacute;lai de cinq (5) ans &agrave;
          compter de la r&eacute;vocation de son consentement &agrave; la
          signification par voie &eacute;lectronique.
        </p>
        <p>
          Le Destinataire est plus particuli&egrave;rement inform&eacute;
          qu&rsquo;il peut conform&eacute;ment aux articles 39 et 40 de la loi
          Informatique et Libert&eacute;s, acc&eacute;der aux donn&eacute;es le
          concernant et en demander, si elles sont inexactes,
          incompl&egrave;tes, &eacute;quivoques ou p&eacute;rim&eacute;es, la
          rectification ou la suppression.
        </p>
        <p>
          Le Destinataire est &eacute;galement inform&eacute; de son droit de
          retirer son consentement &agrave; tout moment, de son droit &agrave;
          la limitation du traitement, de son droit de s&rsquo;opposer au
          traitement, de son droit &agrave; la portabilit&eacute; de ses
          donn&eacute;es et de son droit de d&eacute;finir le sort de ses
          donn&eacute;es apr&egrave;s sa mort.
        </p>
        <p>
          Les droits rappel&eacute;s ci-dessus s&rsquo;exercent en
          &eacute;crivant&nbsp;&agrave; l&rsquo;adresse &eacute;lectronique
          suivante :<a href="mailto:inscription-securact@commissaire-justice.fr"
            >inscription-securact@commissaire-justice.fr</a
          >
        </p>
        <p>
          Le Destinataire est &eacute;galement inform&eacute; qu&rsquo;il
          dispose de la possibilit&eacute; d&rsquo;exercer une
          r&eacute;clamation aupr&egrave;s de l&rsquo;autorit&eacute; de
          contr&ocirc;le (<em>CNIL</em>) &agrave; l&rsquo;adresse
          &eacute;lectronique suivante :
          <a href="https://www.cnil.fr/fr/plaintes" target="_blank"
            >https://www.cnil.fr/fr/plaintes</a
          >
          ou par courrier postal : CNIL, 3 Place de Fontenoy &ndash; TSA 80715
          &ndash; 75334 Paris Cedex 07.
        </p>
        <h6>13 - Gestion des cookies</h6>
        <p>
          En utilisant la Plateforme, le Destinataire est inform&eacute; que des
          informations peuvent &ecirc;tre automatiquement collect&eacute;es
          &agrave; travers l&rsquo;usage normal de la Plateforme et consent
          &agrave; ce que des cookies puissent &ecirc;tre plac&eacute;s sur sa
          machine. Un cookie est un petit fichier texte contenant des
          informations, qui est enregistr&eacute; sur le disque dur du terminal
          (ex : ordinateur, tablette ou t&eacute;l&eacute;phone mobile) du
          Destinataire &agrave; l&rsquo;occasion de la consultation d&rsquo;un
          site internet gr&acirc;ce au logiciel de navigation. Il est transmis
          par le serveur de la Plateforme au navigateur.
        </p>
        <p>
          En utilisant la Plateforme, le Destinataire est inform&eacute; que des
          informations peuvent &ecirc;tre automatiquement collect&eacute;es
          &agrave; travers l&rsquo;usage normal de la Plateforme et consent
          &agrave; ce que des cookies puissent &ecirc;tre plac&eacute;s sur sa
          machine. Un cookie est un petit fichier texte contenant des
          informations, qui est enregistr&eacute; sur le disque dur du terminal
          (ex : ordinateur, tablette ou t&eacute;l&eacute;phone mobile) du
          Destinataire &agrave; l&rsquo;occasion de la consultation d&rsquo;un
          site internet gr&acirc;ce au logiciel de navigation. Il est transmis
          par le serveur de la Plateforme au navigateur.
        </p>
        <p>
          Les cookies sont utilis&eacute;s &agrave; des fins
          d&rsquo;identification du Destinataire &agrave; la Plateforme.
        </p>
        <p>
          Le fichier cookie permet &agrave; son &eacute;metteur d'identifier le
          terminal dans lequel il est enregistr&eacute; pendant la dur&eacute;e
          de validit&eacute; ou d'enregistrement du cookie
          concern&eacute;.&nbsp;
        </p>
        <p>
          Un cookie ne permet pas de remonter directement &agrave; une personne
          physique. Les modalit&eacute;s de gestion des cookies sont
          d&eacute;finies sur la Plateforme dans la rubrique &ldquo;En savoir
          plus&rdquo;.
        </p>
        <h6>14 - Convention de preuve</h6>
        <p>
          Conform&eacute;ment &agrave; l&rsquo;article 1368 du Code civil, le
          Destinataire et la CNCJ s&rsquo;engagent &agrave; respecter les
          stipulations du pr&eacute;sent article constitutives de la convention
          de preuve.&nbsp;
        </p>
        <p>
          Dans le cadre de la relation entre le Destinataire et la CNCJ, la
          preuve des connexions et des op&eacute;rations effectu&eacute;es sur
          la Plateforme sera &eacute;tablie &agrave; la lumi&egrave;re des
          journaux de connexion tenus &agrave; jour par la CNCJ. Le Destinataire
          accepte la force probante de ces journaux de connexions.
        </p>
        <p>
          Le Destinataire accepte express&eacute;ment que les enregistrements
          sur support informatique de la CNCJ constituent la preuve des
          op&eacute;rations effectu&eacute;es au moyen de la Plateforme. En
          cons&eacute;quence, le Destinataire accepte que ces enregistrements
          soient pr&eacute;sum&eacute;s fiables en cas de contestation et soient
          admissibles &agrave; titre de preuve devant les tribunaux.
        </p>
        <h6>15 - Modifications des conditions g&eacute;n&eacute;rales</h6>
        <p>
          Les Conditions G&eacute;n&eacute;rales sont susceptibles
          d&rsquo;&ecirc;tre modifi&eacute;es &agrave; tout moment par la CNCJ
          en cas d&rsquo;&eacute;volution des conditions technologiques et
          r&eacute;glementaires de la Plateforme.
        </p>
        <p>
          Il rel&egrave;ve de la responsabilit&eacute; du Destinataire de
          consulter p&eacute;riodiquement ces Conditions G&eacute;n&eacute;rales
          pour v&eacute;rifier si des modifications y ont &eacute;t&eacute;
          apport&eacute;es. Dans l&rsquo;hypoth&egrave;se o&ugrave; le
          Destinataire continue d&rsquo;utiliser la Plateforme apr&egrave;s la
          publication des modifications apport&eacute;es, ces modifications
          seront r&eacute;put&eacute;es accept&eacute;es.
        </p>
        <h6>16 - Sous-traitance</h6>
        <p>
          Le Destinataire d&eacute;clare et accepte que la CNCJ puisse recourir
          &agrave; un ou plusieurs sous-traitants de son choix en cours
          d&rsquo;ex&eacute;cution des pr&eacute;sentes Conditions
          G&eacute;n&eacute;rales.
        </p>
        <h6>17 - Int&eacute;gralit&eacute;</h6>
        <p>
          Les Conditions G&eacute;n&eacute;rales expriment
          l&rsquo;int&eacute;gralit&eacute; des obligations des parties.
        </p>
        <h6>18 - Nullit&eacute;</h6>
        <p>
          Si une ou plusieurs des stipulations des Conditions
          G&eacute;n&eacute;rales sont tenues pour non valides ou
          d&eacute;clar&eacute;es telles en application d&rsquo;une loi,
          d&rsquo;un r&egrave;glement ou &agrave; la suite d&rsquo;une
          d&eacute;cision d&eacute;finitive d&rsquo;une juridiction
          comp&eacute;tente, les autres stipulations garderont toute leur force
          et leur port&eacute;e.
        </p>
        <h6>19 - Interpr&eacute;tation</h6>
        <p>
          En cas de difficult&eacute; d&rsquo;interpr&eacute;tation de
          l&rsquo;une quelconque des clauses au regard de son intitul&eacute;,
          le contenu de la clause pr&eacute;vaudra sur ce dernier.
        </p>
        <h6>20 - Non renonciation</h6>
        <p>
          Le fait par l'une des Parties de ne pas se pr&eacute;valoir d'un
          manquement de l'autre &agrave; l'une des obligations vis&eacute;es
          dans les Conditions G&eacute;n&eacute;rales ne saurait &ecirc;tre
          interpr&eacute;t&eacute; comme une renonciation &agrave; exiger le
          respect de l'obligation enfreinte.
        </p>
        <h6>21 - Droit applicable</h6>
        <p>
          Les Conditions G&eacute;n&eacute;rales sont soumises, en toutes leurs
          dispositions, au droit fran&ccedil;ais.
        </p>
        <h6>22 - Attribution de comp&eacute;tence</h6>
        <p>
          En cas de litige portant sur l&rsquo;interpr&eacute;tation ou
          l&rsquo;ex&eacute;cution des Conditions G&eacute;n&eacute;rales, les
          Parties s&rsquo;efforceront de trouver une solution amiable au litige
          qui les oppose.
        </p>
        <p>
          A d&eacute;faut de r&eacute;solution amiable du litige entre les
          Parties, celui-ci sera port&eacute; devant&nbsp;les tribunaux du
          ressort de la Cour d&rsquo;appel de Paris.
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'TermsAndConditions',
  methods: {
    getReturnLink() {
      const via = this.$route.query.via;
      if (via === 'entreprise') {
        return { name: 'entrepriseLogin' };
      } else if (via === 'banque') {
        return { name: 'pmcaLogin' };
      } else {
        // Par défaut, rediriger vers la page d'accueil
        return { name: 'home' };
      }
    }
  }
}
</script>